/* eslint-disable @typescript-eslint/naming-convention */

export const fields = [
  'name',
  'email',
  'gender',
  'dateOfBirth',
  'correspondenceLanguage',
  'phoneNumber',
  'optionalPhoneNumber',
  'socialInsuranceNumber',
  'completeAddress',
  'postalCode',
  'apartment',
  'emergencyContact',
  'signatureImageUrl',
  'chequebookImageUrl',
  'workPermitImageUrl',
  'workPermitEndDate',
  'address',
  'documentIdImageUrl',
  'firstName',
  'middleName',
  'lastName',
  'nickname',
  'bankAccountNumber',
  'routingNumber',
  'branchTransitNumber',
  'financialInstitutionNumber',
  'addressLineOne',
  'addressLineTwo',
  'city',
  'region',
  'country',
  'contractDetailsWordings',
  'emergencyContactFirstName',
  'emergencyContactLastName',
  'emergencyContactPhoneNumber',
  'codeofconductandethics',
  'privacynoticeforemployees',
  'electronicmonitoringpolicy',
];

export enum COMPONENT_ADVANCED_FIELDS {
  bankAccountNumber = 'bankAccountNumber',
  routingNumber = 'routingNumber',
  branchTransitNumber = 'branchTransitNumber',
  financialInstitutionNumber = 'financialInstitutionNumber',
  socialInsuranceNumber = 'socialInsuranceNumber',
  socialSecurityNumber = 'socialSecurityNumber',
  workPermitType = 'workPermitType',
  workPermitEndDate = 'workPermitEndDate',
  workPermitImageUrl = 'workPermitImageUrl',
  signature = 'signature',
  chequebookImageUrl = 'chequebookImageUrl',
  emergencyContact = 'emergencyContact',
  emergencyContactFirstName = 'emergencyContactFirstName',
  emergencyContactLastName = 'emergencyContactLastName',
  emergencyContactPhoneNumber = 'emergencyContactPhoneNumber',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  address = 'address',
}

export enum COMPONENT_FIELDS {
  name = 'name',
  email = 'email',
  gender = 'gender',
  dateOfBirth = 'dateOfBirth',
  correspondenceLanguage = 'correspondenceLanguage',
  phoneNumber = 'phoneNumber',
  optionalPhoneNumber = 'optionalPhoneNumber',
  socialInsuranceNumber = 'socialInsuranceNumber',
  socialSecurityNumber = 'socialSecurityNumber',
  completeAddress = 'completeAddress',
  apartment = 'apartment',
  emergencyContact = 'emergencyContact',
  signatureImageUrl = 'signatureImageUrl',
  chequebookImageUrl = 'chequebookImageUrl',
  workPermitImageUrl = 'workPermitImageUrl',
  workPermitEndDate = 'workPermitEndDate',
  address = 'address',
  documentIdImageUrl = 'documentIdImageUrl',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  nickname = 'nickname',
  bankAccountNumber = 'bankAccountNumber',
  routingNumber = 'routingNumber',
  branchTransitNumber = 'branchTransitNumber',
  financialInstitutionNumber = 'financialInstitutionNumber',
  addressLineOne = 'addressLineOne',
  addressLineTwo = 'addressLineTwo',
  city = 'city',
  region = 'region',
  postalCode = 'postalCode',
  country = 'country',
  contractDetailsWordings = 'contractDetailsWordings',
  emergencyContactFirstName = 'emergencyContactFirstName',
  emergencyContactLastName = 'emergencyContactLastName',
  emergencyContactPhoneNumber = 'emergencyContactPhoneNumber',
  endDate = 'endDate',
  codeofconductandethics = 'codeofconductandethics',
  privacynoticeforemployees = 'privacynoticeforemployees',
  electronicmonitoringpolicy = 'electronicmonitoringpolicy',
  earliestAvailabilityDate = 'earliestAvailabilityDate',
  signature = 'signature',
  workPermitType = 'workPermitType',
  legalFirstName = 'legalFirstName',
  legalMiddleName = 'legalMiddleName',
  legalLastName = 'legalLastName',
}
